import { render, staticRenderFns } from "./SigninProcess.vue?vue&type=template&id=4c3fff30&scoped=true&lang=pug&"
import script from "./SigninProcess.vue?vue&type=script&lang=js&"
export * from "./SigninProcess.vue?vue&type=script&lang=js&"
import style0 from "./SigninProcess.vue?vue&type=style&index=0&id=4c3fff30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fff30",
  null
  
)

export default component.exports